import { Form, useFormContext } from "@/components/form";
import { FormFieldWithError } from "@/components/form/form-field-with-error";
import { CollapsibleSection } from "@/components/form/collapsible-section";
import { Stack, Typography } from "@mui/material";

export default function DEComprasPublicasFields() {
    const form = useFormContext();

    return (
        <CollapsibleSection title="Informaciones de Compras Públicas (B2G)">
            <Typography variant="body2" color="text.secondary" mb={1.5}>
                Campos opcionales para operaciones Business to Government (B2G). Códigos emitidos por la DNCP.
            </Typography>
            <Stack direction={{ xs: "column", sm: "row" }} gap={1.5} flexWrap="wrap" alignItems="flex-start">
                <FormFieldWithError
                    name="dModCont"
                    label="Modalidad"
                    size="small"
                    width={{ xs: "100%", sm: "120px" }}
                    slotProps={{ htmlInput: { maxLength: 2 } }}
                />

                <FormFieldWithError
                    name="dEntCont"
                    label="Entidad"
                    size="small"
                    width={{ xs: "100%", sm: "160px" }}
                    inputMode="numeric"
                    slotProps={{ htmlInput: { maxLength: 5 } }}
                />

                <FormFieldWithError
                    name="dAnoCont"
                    label="Año"
                    size="small"
                    width={{ xs: "100%", sm: "120px" }}
                    inputMode="numeric"
                    slotProps={{ htmlInput: { maxLength: 2 } }}
                />

                <FormFieldWithError
                    name="dSecCont"
                    label="Secuencia"
                    size="small"
                    width={{ xs: "100%", sm: "180px" }}
                    inputMode="numeric"
                    slotProps={{ htmlInput: { maxLength: 7 } }}
                />

                <form.Field name="dFeCodCont">
                    {(field) => {
                        const raw = field.state.meta?.errors?.[0];
                        const isTouched = field.state.meta.isTouched;
                        const errorMsg = raw
                            ? (typeof raw === "string" ? raw : (raw as any)?.message ?? "")
                            : null;
                        // Si el campo fue tocado, RegisterField interno del DatePicker muestra el error.
                        // Si no fue tocado (submit sin interacción), lo mostramos con Typography.
                        return (
                            <Stack width={{ xs: "100%", sm: "260px" }} height={errorMsg ? "70px" : "auto"}>
                                <Form.DatePicker
                                    name="dFeCodCont"
                                    label="Fecha Código Contratación"
                                    size="small"
                                />
                                {errorMsg && !isTouched && (
                                    <Typography variant="caption" color="error" mt={0.5} ml={1.5}>
                                        {errorMsg}
                                    </Typography>
                                )}
                            </Stack>
                        );
                    }}
                </form.Field>
            </Stack>
        </CollapsibleSection>
    );
}
